import { useEffect } from "react";
import { Box, Container } from "@mui/material";
import { analytics, WrapperStyles } from "../shared/utils";
import DownloadOverlay from "./overlays/DownloadOverlay";
import FooterOverlay from "./overlays/FooterOverlay";

const RootView = () => {
  useEffect(() => {
    analytics.screen("Web/Root");
  }, []);

  return (
    <Container
      maxWidth={false}
      sx={{
        minHeight: "100vh",
        flexDirection: "column",
        display: "flex",
        px: "0 !important",
      }}
    >
      <Box sx={WrapperStyles}>
        <Box style={{ marginTop: 100 }} />
        <DownloadOverlay
          parentViewName="Root"
          backgroundId="background-2.jpg"
        />
        <Box sx={{ my: 8 }} />
        <FooterOverlay />
      </Box>
    </Container>
  );
};

export default RootView;
